import { compact, concat, isEmpty, reduce } from 'lodash';

const highlightTerm = (text, term) => {
  if (isEmpty(term)) {
    return text;
  }

  const pattern = new RegExp(term.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'gi');
  const a = text.split(pattern);
  const r = text.match(pattern);

  if (!r) {
    return text;
  }

  const comp = a.map((val, index) =>
    concat(val, r[index] ? r[index] : null).join('')
  );

  return compact(comp).join('');
};

export default highlightTerm;
